import { Component, h, Host, Prop } from "@stencil/core";
import { Logo } from "./logo";
@Component({
    tag: "ux-iws-sf-page-title",
    styleUrl: "sf-page-title.scss",
    shadow: false,
})
export class SfPageTitle {
    /** Variant of the page component */
    @Prop({ reflect: true }) variant: "h1-logo" | string = "h1-logo";

    render() {
        return (
            <Host>
                {this.variant.includes("logo") && <Logo />}
                <slot />
            </Host>
        );
    }
}
